import { IServerSideGetRowsParams, StringFilterInput } from '@access-erp/common';

import { ContractFilterInput, InputMaybe } from '@/graphql/contracts/_generated_/contracts';

interface ContractFilterInputWithCurrency extends ContractFilterInput {
  contractCurrency?: InputMaybe<StringFilterInput>;
}

export const mapColumnConfigsWithSavedFilters = (
  filtersFromSavedSearch: ContractFilterInputWithCurrency,
  columnParams: IServerSideGetRowsParams,
) => {
  return columnParams.context.filters.current.filters.map((columnConfigs: any) => {
    const basicConfigs = {
      name: columnConfigs.name,
      type: columnConfigs.type,
      label: columnConfigs.label,
    };
    const mainFilterName = columnConfigs.name.includes('.')
      ? columnConfigs.name.split('.')?.[0]
      : null;
    const nestedFilterName = columnConfigs.name.includes('.')
      ? columnConfigs.name.split('.')?.[1]
      : null;

    return {
      ...basicConfigs,
      value: nestedFilterName
        ? (filtersFromSavedSearch as any)[mainFilterName]?.[nestedFilterName]
        : (filtersFromSavedSearch as any)[columnConfigs.name],
    };
  });
};
